"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exhaustMap = exhaustMap;

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _OuterSubscriber2 = require("../OuterSubscriber");

var _subscribeToResult = require("../util/subscribeToResult");

/* tslint:enable:max-line-length */

/**
 * Projects each source value to an Observable which is merged in the output
 * Observable only if the previous projected Observable has completed.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link exhaust}.</span>
 *
 * <img src="./img/exhaustMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. When it projects a source value to
 * an Observable, the output Observable begins emitting the items emitted by
 * that projected Observable. However, `exhaustMap` ignores every new projected
 * Observable if the previous projected Observable has not yet completed. Once
 * that one completes, it will accept and flatten the next projected Observable
 * and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000).take(5));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaust}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable containing projected Observables
 * of each item of the source, ignoring projected Observables that start before
 * their preceding Observable has completed.
 * @method exhaustMap
 * @owner Observable
 */
function exhaustMap(project, resultSelector) {
  return function (source) {
    return source.lift(new SwitchFirstMapOperator(project, resultSelector));
  };
}

var SwitchFirstMapOperator =
/*#__PURE__*/
function () {
  function SwitchFirstMapOperator(project, resultSelector) {
    (0, _classCallCheck2.default)(this, SwitchFirstMapOperator);
    this.project = project;
    this.resultSelector = resultSelector;
  }

  (0, _createClass2.default)(SwitchFirstMapOperator, [{
    key: "call",
    value: function call(subscriber, source) {
      return source.subscribe(new SwitchFirstMapSubscriber(subscriber, this.project, this.resultSelector));
    }
  }]);
  return SwitchFirstMapOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */


var SwitchFirstMapSubscriber =
/*#__PURE__*/
function (_OuterSubscriber) {
  (0, _inherits2.default)(SwitchFirstMapSubscriber, _OuterSubscriber);

  function SwitchFirstMapSubscriber(destination, project, resultSelector) {
    var _this;

    (0, _classCallCheck2.default)(this, SwitchFirstMapSubscriber);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SwitchFirstMapSubscriber).call(this, destination));
    _this.project = project;
    _this.resultSelector = resultSelector;
    _this.hasSubscription = false;
    _this.hasCompleted = false;
    _this.index = 0;
    return _this;
  }

  (0, _createClass2.default)(SwitchFirstMapSubscriber, [{
    key: "_next",
    value: function _next(value) {
      if (!this.hasSubscription) {
        this.tryNext(value);
      }
    }
  }, {
    key: "tryNext",
    value: function tryNext(value) {
      var index = this.index++;
      var destination = this.destination;

      try {
        var result = this.project(value, index);
        this.hasSubscription = true;
        this.add((0, _subscribeToResult.subscribeToResult)(this, result, value, index));
      } catch (err) {
        destination.error(err);
      }
    }
  }, {
    key: "_complete",
    value: function _complete() {
      this.hasCompleted = true;

      if (!this.hasSubscription) {
        this.destination.complete();
      }
    }
  }, {
    key: "notifyNext",
    value: function notifyNext(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
      var resultSelector = this.resultSelector,
          destination = this.destination;

      if (resultSelector) {
        this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
      } else {
        destination.next(innerValue);
      }
    }
  }, {
    key: "trySelectResult",
    value: function trySelectResult(outerValue, innerValue, outerIndex, innerIndex) {
      var resultSelector = this.resultSelector,
          destination = this.destination;

      try {
        var result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        destination.next(result);
      } catch (err) {
        destination.error(err);
      }
    }
  }, {
    key: "notifyError",
    value: function notifyError(err) {
      this.destination.error(err);
    }
  }, {
    key: "notifyComplete",
    value: function notifyComplete(innerSub) {
      this.remove(innerSub);
      this.hasSubscription = false;

      if (this.hasCompleted) {
        this.destination.complete();
      }
    }
  }]);
  return SwitchFirstMapSubscriber;
}(_OuterSubscriber2.OuterSubscriber);